import React from "react";
import { Redirect } from "react-router-dom";

const SignInPage = props => {
  console.log("MAYS SignInPage");
  console.log("\t\tMAYS authProps", props.authProps);

  if (props.authProps.isAuthenticated && props.authProps.user) {
    return <Redirect to="/" />;
  } else {
    return null;
  }
};

export default SignInPage;
